import {api} from './api';
import { Course } from '../model/course';

export const getCourses = async (accessToken: string): Promise<Course[]> => {
    const response = await api.get<Course[]>(`/courses`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data;
};

export const getCourse = async (accessToken: string, uuid: string): Promise<Course> => {
    const response = await api.get<Course>(`/courses/${uuid}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data;
};

export const putCourse = async (accessToken: string, uuid: string, course: Course): Promise<Course> => {
    const response = await api.put<Course>(`/courses/${uuid}`, 
        course, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });
    return response.data;
};

export const reorderCourse = async (accessToken: string, uuid: string, index: number): Promise<boolean> => {
    if (uuid == undefined || uuid == null || Number.isNaN(index) || index == undefined) {
        console.error(`invalid input uuid: ${uuid} index: ${index}`)
        return false
    }

    const response = await api.put<Course>(`/courses/${uuid}/index/${index}`, 
        {}, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    return response.status == 200 || response.status == 204;
};

export const deleteCourse = async (accessToken: string, courseId: string): Promise<boolean> => {
    const response = await api.delete<boolean>(`/courses/${courseId}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
        },
    });

    return response.status == 204 || response.status == 200
};